import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

export const Route = createFileRoute("/hvac-maintenance-louisville-ky")({
  beforeLoad: () => legacyRedirect("/hvac-services/hvac-preventative-maintenance"),
});
